import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  private previousUrl: string = '';
  private currentUrl: string = '';
  public redirectUrl: string = '';

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        this.previousUrl = this.currentUrl;
      }
    });
  }

  getPreviousUrl(): string {
    return this.previousUrl;
  }
}
